import { render, staticRenderFns } from "./ParentForm.vue?vue&type=template&id=2bd26fa9&scoped=true&"
import script from "./ParentForm.vue?vue&type=script&lang=js&"
export * from "./ParentForm.vue?vue&type=script&lang=js&"
import style0 from "./ParentForm.vue?vue&type=style&index=0&id=2bd26fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd26fa9",
  null
  
)

export default component.exports